export const BASIC = 'BASIC';
export const RECOMMENDED = 'RECOMMENDED';
export const PREMIUM = 'PREMIUM';
export const types = [BASIC, RECOMMENDED, PREMIUM];
export const BUNDLE_PRODUCT = 'bundleProduct';
export const FORM_SECTION = 'ancillaryBundle';